__turbopack_context__.v({
  "pdf-document-content": "sGX8RG_pdf-document-content",
  "pdf-document-content--locale-adjusted-font": "sGX8RG_pdf-document-content--locale-adjusted-font",
  "pdf-document-content--printable": "sGX8RG_pdf-document-content--printable",
});
